import React, { useState } from "react";
import { SpinnerCircularFixed } from "../../../../assets/spinner/SpinnerCircularFixed";
import { NoImage as NoImageIcon } from "../../../../assets/NoImage";
import { EyeIcon } from "../../../../assets/EyeIcon";
import { ExampleModal } from "./CarouselExampleModal";
import LogoExample from "../../../../assets/LogoExample.png";

interface SlideLogoSectionProps {
    logoSrc: string;
    isRestricted: boolean;
    isUploading: boolean;
    onImageUpload: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onRemove: () => void;
}

export const CarouselSlideEditorLogoSection: React.FC<SlideLogoSectionProps> = ({
    logoSrc,
    isRestricted,
    isUploading,
    onImageUpload,
    onRemove,
}) => {
    const [showExample, setShowExample] = useState(false);

    return (
        <section className="editSection editSection--logo">
            <div className="editSection__head">
                <div className="title">Logo</div>
                <button type="button" className="seeExample" onClick={() => setShowExample(true)}>
                    <span className="eyeIcon" />See Example <EyeIcon />
                </button>
            </div>

            <p>Add a Logo <span>(Optional)</span></p>

            <div className="logoCard">
                <div className="logoPreview">
                    <div className="logoEmpty">
                        {isUploading ? (
                            <SpinnerCircularFixed
                                size={25}
                                thickness={140}
                                speed={120}
                                color="rgb(145,145,145)"
                                secondaryColor="rgba(0,0,0,.44)"
                            />
                        ) : logoSrc ? (
                            <img
                                src={decodeURIComponent(logoSrc)}
                                alt="Logo preview"
                                className="logoPreview__img"
                                draggable={false}
                            />
                        ) : (
                            <div className="logoPlaceholder">
                                <NoImageIcon />
                                <span>Upload Logo (png)</span>
                            </div>
                        )}
                    </div>
                </div>
                <div className="actions">
                    <input
                        type="file"
                        id="logo"
                        accept=".png,.jpg,.jpeg"
                        onChange={onImageUpload}
                        disabled={isRestricted}
                    />
                    <div className="uploaderControl">
                        <label htmlFor="logo" className="btnUpload" aria-label="Upload">
                            <span className="icoUpload" aria-hidden="true" />
                        </label>
                        <label htmlFor="logo" className="uploadText">Upload</label>
                    </div>
                    <div className="uploaderControl">
                        <button
                            type="button"
                            className="btnRemove"
                            onClick={onRemove}
                            disabled={isRestricted}
                        >
                            <span className="icoTrash" />
                        </button>
                        <span>Remove</span>
                    </div>
                </div>
            </div>

            <p className="logoNote">
                Visible on desktop and mobile. Recommended PNG transparent background, max 250 px width, 60 px height
            </p>
            
            <ExampleModal
                title="Logo example"
                imageSrc={LogoExample}
                open={showExample}
                onClose={() => setShowExample(false)}
            />
        </section>
    );
};